import styles from './PinterestPostPreview.pcss'
import StarIcon from '@mui/icons-material/StarBorderRounded'
import { PostPreviewVideoPlayer } from './PostPreviewVideoPlayer'

interface PinterestPostPreviewProps {
  imageUrl?: string
  videoUrl?: string
  text?: string
  empty?: boolean
}

export function PinterestPostPreview(props: PinterestPostPreviewProps) {
  return (
    <article className={`${!props.imageUrl && !props.videoUrl ? styles['no-img'] : ''} ${props.empty ? styles.empty : ''} ${styles.pin}`}>
      {props.videoUrl ? (
        <PostPreviewVideoPlayer videoUrl={props.videoUrl} className={styles['pi-vid']} />
      ) : (
        <div className={styles['img-box']}>
          <img src={props.imageUrl} className={styles.image} />
          <div className={styles['icon-zoom']}></div>
        </div>
      )}
      <div className={styles['title-box']}>
        {props.text ? (
          <h3 className={styles.title}>{props.text}</h3>
        ) : (
          <div className={styles['text-empty-box']}>
            <div></div>
            <div></div>
          </div>
        )}
        <StarIcon className={styles.icon} />
      </div>
    </article>
  )
}
